import type {
  GetAnalyticsCallDetailsQuery,
  GetAnalyticsCallDetailsQueryVariables,
} from "@/graphql/generated/graphql";
import { GetAnalyticsCallDetails } from "@/graphql/queries/GetAnalyticsCallDetails";
import { useQueryWrapper } from "../useQueryWrapper/useQueryWrapper";
import type { UseAnalyticsCallDetailsReturn } from "./useAnalyticsCallDetails.decl";

export function useAnalyticsCallDetails(
  callId: string
): UseAnalyticsCallDetailsReturn {
  const { data, loading, error } = useQueryWrapper<
    GetAnalyticsCallDetailsQuery,
    GetAnalyticsCallDetailsQueryVariables
  >(GetAnalyticsCallDetails, {
    variables: {
      input: {
        callId,
      },
    },
    skip: !callId,
  });

  const disconnectedBy =
    data?.analyticsCallDetails?.__typename === "AnalyticsCallDetails"
      ? (data.analyticsCallDetails.disconnectedBy ?? undefined)
      : undefined;

  return {
    disconnectedBy,
    loading,
    error,
  };
}
